import { ISODateString } from './time';

export enum CommandStatus {
  CREATED = 'CREATED',
  PUBLISHED = 'PUBLISHED',
  ACK = 'ACK',
  STARTED = 'STARTED',
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  CANCELLED = 'CANCELLED',
}
export interface DeviceCommand {
  command_id: string;
  type: string;
  device_id: string;
  status?: string;
  created_at: string;
  fleet_uuid: string;
  trace_id: string;
  timeout_at: ISODateString;
  payload: string; // JSON string
  created_by: string;
  updated_at: ISODateString;
}

export interface CommandTrace {
  trace_id: string;
  commands: DeviceCommand[];
}

export interface SearchCommandsResponse {
  items: CommandTrace[];
}

export interface SearchCommandsRequest {
  device_ids?: string[];
  command_types?: string[];
  command_statuses?: CommandStatus[];
}
